import * as stylex from '@stylexjs/stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex.ts';
import { colors } from '@shared/tokens/colors.stylex.ts';
import { palette } from '@shared/tokens/palette.stylex.ts';
import { typography } from '@shared/tokens/typography.stylex.ts';

export const styles = stylex.create({
  bubbleMenu: {
    position: 'relative',
    width: 'min-content',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    height: anatomy['size-16'],
    gap: anatomy['space-8'],
    color: colors.secondaryBackground,
    ':not(#__unused__) > button > svg': {
      width: anatomy['size-16'],
      height: anatomy['size-16'],
    },
    ':not(#__unused__) > button:hover': {
      color: `${colors.accentText}`,
    },
    ':not(#__unused__) > button:disabled': {
      color: colors.foregroundTertiary,
      cursor: 'not-allowed',
    },
    ':not(#__unused__) > button:disabled:hover': {
      color: colors.foregroundTertiary,
    },
  },
  menuActive: {
    background: colors.activeBackground,
    borderRadius: anatomy.borderRadiusXs,
  },
  linkContainer: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: 0,
    borderStyle: 'solid',
    borderColor: 'transparent',
  },
  link: {
    width: '100%',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    background: 'transparent',
    border: `1px solid ${palette['darked-10']}`,
    borderRadius: anatomy.borderRadiusS,
    outline: 'none',
    padding: `${anatomy['space-8']} ${anatomy['space-16']}`,
    height: anatomy['size-36'],
    '::placeholder': {
      color: palette['grey-500'],
    },
  },
  linkError: {
    borderColor: colors.errorBorder,
  },
  linkErrorText: {
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: anatomy['size-12'],
    color: colors.errorText,
    marginBottom: '-2px',
  },
});
